import { Routes } from '@/globalTypes.ts';
import { MenuItemConfig } from '@/components/Header/types.ts';
import { useCompanyInfoQuery } from '@/api/methods/useCompanyInfoQuery.ts';
import { useMemo } from 'react';
import { CompanyInfo, Permission } from '@/api/customTypes.ts';

const navigationItemsConfig: MenuItemConfig[] = [
  {
    label: 'Employees',
    pathname: Routes.EmployeeList,
    mobileStyles: {
      fontWeight: '700',
    },
  },
  // {
  //   label: 'Request Employee',
  //   pathname: Routes.RequestEmployeeList,
  // },
  {
    label: 'Candidates',
    pathname: Routes.LeadsByAgency,
    routePattern: '/manager/leads/:type/',
    permission: () => true, // to not exclude from default isInterviewOnly permission
    styles: {
      color: 'green',
    },
  },
  {
    label: 'Hours by day',
    pathname: Routes.TrackingByDay,
  },
  {
    label: 'Invoices',
    pathname: Routes.InvoiceList,
    styles: {
      color: '#FE4C4C',
    },
    mobileStyles: {
      fontWeight: '500',
    },
  },
  {
    label: 'Billing',
    pathname: Routes.Billing,
    permission: (companyInfo: CompanyInfo | undefined) => {
      if (!companyInfo) {
        return false;
      }
      return companyInfo.access.permissions.includes(Permission.CAN_BILLING);
    },
  },
  {
    label: 'Schedule',
    pathname: Routes.ScheduleList,
    styles: {
      color: 'green',
    },
    mobileStyles: {
      fontWeight: '500',
    },
  },
  {
    label: 'Lost Hours',
    pathname: Routes.LostHoursList,
  },
  {
    label: 'Open Positions',
    pathname: Routes.OpenPositions,
    permission: (companyInfo: CompanyInfo | undefined) => {
      if (!companyInfo) {
        return false;
      }
      return companyInfo.access.permissions.includes(Permission.CAN_POSITIONS);
    },
  },
  {
    label: 'TurnOver',
    pathname: Routes.TurnOver,
    mobileStyles: {
      fontWeight: '700',
    },
  },
];

export const useNavigationMenuItems = (): MenuItemConfig[] => {
  const { data: companyInfo, isLoading } = useCompanyInfoQuery();

  return useMemo(() => {
    const isInterviewOnly =
      isLoading ||
      companyInfo?.access?.permissions?.includes(Permission.CAN_CANDIDATES);

    const items = isInterviewOnly
      ? navigationItemsConfig.filter((item) => !!item.permission)
      : navigationItemsConfig;
    return items.filter((item) => {
      if (!item.permission) return true;
      return item.permission(companyInfo);
    });
  }, [companyInfo]);
};
